export class PropertyOptionsService {
  public static readonly defaultColors: string[] = [
    '#FF6B6B', // soft red
    '#FFD93D', // warm yellow
    '#6BCB77', // fresh green
    '#4D96FF', // bright blue
    '#A66DD4', // lavender purple
    '#FF9F1C', // orange
    '#2EC4B6', // teal
    '#E71D36', // crimson
    '#9BC53D', // lime green
    '#5C5470', // muted violet
  ]

  public nextDefaultColor(newOptionIndex: number): string {
    const index = newOptionIndex % PropertyOptionsService.defaultColors.length
    return PropertyOptionsService.defaultColors[index]
  }
}
